import React from "react";

import PropTypes from "prop-types";
import classNames from "classnames";

export default function Panel({ className, title, children, footer }) {
  return (
    <div className={classNames("panel", className)}>
      {title &&
       <div className="panel-heading">
         <div className="panel-title">{title}</div>
       </div>}
      <div className="panel-content">
        <div className="panel-body">
          {children}
        </div>
        {footer && <div className="panel-footer">{footer}</div>}
      </div>
    </div>
  );
}

Panel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  footer: PropTypes.element,
  title: PropTypes.node
};
